import { create } from 'zustand';
import { getEmirates } from '../api/providerApi';

const useEmiratesStore = create((set) => ({
    emirates: [],
    loading: false,
    error: null,

    fetchEmirates: async () => {
        set({ loading: true, error: null });

        try {
            const data = await getEmirates();
            set({ emirates: data, loading: false });
        } catch (err) {
            set({
                error: err.message || 'Failed to load emirates',
                loading: false,
            });
        }
    },
}));

export default useEmiratesStore;
